function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgServicos2 = function SvgServicos2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.22 1.287l-.648.453a.907.907 0 01-1.26-.223l-.335-.478-.12-.169L7.27.59a1.203 1.203 0 00-1.394.976l-.731 4.149a1.203 1.203 0 00.975 1.394l1.386.244.204.036.63-.443a.907.907 0 011.246.2l.25.336L7.435 21.12a1.905 1.905 0 001.547 2.208l.682.12a1.907 1.907 0 002.208-1.543l2.377-13.363.027-.15.062-.348.088-.493h-.001l.004-.028a.907.907 0 011.434-.57l3.76 3.181.293.248 1.456-1.01-2.224-5.856c-.287-.588-.8-.972-1.397-1.078l-6.53-1.15zm-2.8 20.007l2.353-13.365 2.49.44-2.377 13.36a.906.906 0 01-1.05.734l-.682-.12a.905.905 0 01-.735-1.049zm8.063-15.123l3.492 2.953.184-.128-1.927-5.08a.908.908 0 00-.656-.492l-6.122-1.08-.31.216c-.86.6-2.045.392-2.65-.467l-.217-.309-1.18-.208a.203.203 0 00-.236.165l-.732 4.148c-.02.11.055.216.165.236l1.181.208.292-.205a1.907 1.907 0 012.62.42l.257.344 2.793.492.007-.034c.246-1.396 1.876-2.044 3.039-1.18z",
    fill: props.color
  }));
};
SvgServicos2.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgServicos2.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgServicos2;